export default __webpack_public_path__ + "static/media/puolesta-asiointi.468edae8.svg";